var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcCabCapsuleFilePhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 8.9,
    width: 30.2,
    height: 22.2,
    rx: 4.5,
    stroke: "#FFFFFF",
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.2,
    cy: 17.4,
    r: 2.7,
    stroke: "#FFFFFF",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 28.4L14.4 21.9C15.5 21 17.1 21.1 18 22.1L23.6 28.4M21.6 26.2L24.9 23.4C25.9 22.5 27.4 22.5 28.4 23.4L33.5 27.7",
    stroke: "#FFFFFF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcCabCapsuleFilePhotoIcon);
export default __webpack_public_path__ + "static/media/tc_cab_capsule_file_photo_icon.c65aae15bc2bb86c9382d4e93756e904.svg";
export { ForwardRef as ReactComponent };